import styles from "./tablePanel.module.scss";
import SBEditable from "../../components/sbEditable/sbEditable";
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import StickyTableHeader from "../../helpers/StickyTableHeader";
import useResizeObserver from "../../hooks/useResizeObserver.js";
import { ArticlePanelOptionsToClasses } from "../articlepanels/articlePanelHelpers";

function TablePanel({ blok }) {
  const tableRef = useRef(null);
  const tableCloneRef = useRef(null);
  const [desktopScreenSize, setDesktopScreenSize] = useState(
    !window.matchMedia("(max-width: 992px)").matches
  );

  const handleScreenSizeChange = (e) => setDesktopScreenSize(!e.matches);

  useEffect(() => {
    window
      .matchMedia("(max-width: 992px)")
      .addEventListener("change", handleScreenSizeChange);

    return () => {
      window
        .matchMedia("(max-width: 992px)")
        .removeEventListener("change", handleScreenSizeChange);
    };
  }, []);

  const [resizeRef, { contentRect }] = useResizeObserver(100);
  const tableWidth = contentRect ? contentRect.width : 0;

  useEffect(() => {
    if (tableCloneRef.current && tableRef.current) {
      var bodyRectY = document.body.getBoundingClientRect().y;
      var tableRect = tableRef.current.getBoundingClientRect();
      var tableTop = tableRect.y - bodyRectY;

      var diffTop = window.scrollY - tableTop;
      var topPx = desktopScreenSize ? 105 : 66; //todo need to calculate the nav height instead of hardcoding it
      if (diffTop <= -topPx && tableCloneRef.current.style.display === "block") {
        tableCloneRef.current.style.display = "none";
      }
    }
  }, [tableWidth]);

  const stickyFirstColumnClassName = blok.sticky_first_column
    ? styles.stickyFirstColumn
    : "";

  //useEffect is async, so using instead of useLayoutEffect to prevent potential lag
  useEffect(() => {
    //Add a thead if there is a header row
    if (
      !tableRef.current.querySelector("thead") &&
      tableRef.current.querySelector("table tbody tr:nth-child(2) th") //if second column has header on first row assume it is a header row and convert to thead
    ) {
      //insert a thead around the first row so the StickyTableHeader class can work
      const table = tableRef.current.querySelector("table");
      const thead = document.createElement("thead");
      const tbody = tableRef.current.querySelector("tbody");
      const firstRow = tableRef.current.querySelector("tr:first-child");

      table.insertBefore(thead, tbody);
      tbody.removeChild(firstRow);
      thead.appendChild(firstRow);
    }

    if (
      tableRef.current &&
      tableCloneRef.current &&
      blok.sticky_table_row_header &&
      tableRef.current.querySelector("thead") //only works with a header row
    ) {
      // Initialize the sticky header.
      const sticky = new StickyTableHeader(
        tableRef.current.querySelector("table"),
        tableCloneRef.current.querySelector("table"),
        { max: desktopScreenSize ? 105 : 66 }
      );
      // Make sure to destory the sticky header once the main table is unmounted.
      return () => {
        sticky.destroy();
      };
    }
    //tableWidth as a dependency ensures we rerun this when the screensize changes to recalculate column header widths for the cloned header
  }, [
    tableWidth,
    desktopScreenSize,
    tableRef.current,
    tableCloneRef.current,
    blok.sticky_table_row_header,
  ]);

  return (
    <SBEditable
      withClass={`${styles.root} ${ArticlePanelOptionsToClasses(blok)}`}
      blok={blok}
    >
      <div
        ref={tableRef}
        className={`${styles.table} ${styles.forceWidth} ${stickyFirstColumnClassName}`}
        dangerouslySetInnerHTML={{ __html: `${blok.table.content}` }}
      />
      <div
        ref={tableCloneRef}
        className={`${styles.table} ${styles.tableClone} ${stickyFirstColumnClassName}`}
      >
        <table ref={resizeRef} />
      </div>
    </SBEditable>
  );
}

export default TablePanel;
